

const SmartCity = () => {
    return (
        <>
            <div className="bg-[var(--lavendar)] py-12 sm:pt-32 xl:pt-32">
                <div className="text-center place-items-center">
                    <h3 className="text-[var(--ultraviolet)] font-uiBold text-base lg:text-xl xl:text-2xl leading-5">
                        SMART CITY SOLUTIONS</h3>
                    <div className='my-6 lg:my-10'> 
                        <h1 className="text-[var(--kaizekblue)] font-symbol font-semibold text-2xl sm:text-3xl lg:text-4xl xl:text-5xl leading-tight sm:pb-2">
                        Intelligent Urban Infrastructure Solutions</h1>
                    </div>
                    <div className='flex m-auto justify-center'>
                    <p className="text-[var(--lightgray)] flex place-self-center text-center font-symbol text-base lg:text-2xl lg:mt-8 w-11/12 sm:w-8/12 2xl:w-5/12">
                    Comprehensive smart city solutions including lighting control, 
                    environmental monitoring, and urban infrastructure management.
                    </p>
                    </div>
                </div>

                <div className="lg:max-w-[1200px] 2xl:max-w-[1380px] m-auto">
                    <div className='mt-12 xl:mt-20 grid grid-flow-row gap-4 lg:gap-6 xl:gap-8 lg:py-4'>
                        <div className='grid lg:grid-cols-3 gap-4 mx-4 sm:mx-8'>
                            <div className='py-4'>                    
                                <h2 className='font-uiSemilight text-3xl sm:text-4xl lg:text-5xl text-[var(--kaizekblue)]'>
                                Key Features</h2>
                            </div>
                            <div className='col-span-2 py-4 sm:py-8 lg:py-14 px-4 sm:px-8 bg-[var(--ultraviolet)] rounded-xl lg:rounded-3xl'>
                                <ul className="font-symbol leading-tight text-[var(--whitetext)] text-base sm:text-2xl ms-4 lg:ms-8 xl:ms-12 px-2 list-outside space-y-2 text-left list-disc">
                                    <li>Intelligent lighting control</li>
                                    <li>Environmental monitoring</li>
                                    <li>Traffic management systems</li>
                                    <li>Infrastructure monitoring</li>
                                    <li>Emergency response integration</li>
                                </ul>
                            </div>
                        </div>
                        <div className='grid lg:grid-cols-3 gap-4 mx-4 sm:mx-8'>
                            <div className='py-4'>                    
                                <h2 className='font-uiSemilight text-3xl sm:text-4xl lg:text-5xl text-[var(--kaizekblue)] xl:w-10/12'>
                                Smart Lighting Control</h2>
                            </div>
                            <div className='col-span-2 py-4 sm:py-8 lg:py-14 px-4 sm:px-8 bg-[var(--ultraviolet)] rounded-xl lg:rounded-3xl'>
                                <ul className="font-symbol leading-tight text-[var(--whitetext)] text-base sm:text-2xl ms-4 lg:ms-8 xl:ms-12 px-2 list-outside space-y-2 text-left list-disc">
                                    <li>Individual light control</li>
                                    <li>Automated scheduling</li>
                                    <li>Energy monitoring</li>
                                    <li>Maintenance alerts</li>
                                </ul>
                            </div>
                        </div>
                        <div className='grid lg:grid-cols-3 gap-4 mx-4 sm:mx-8'>
                            <div className='py-4'>                    
                                <h2 className='font-uiSemilight text-3xl sm:text-4xl lg:text-5xl text-[var(--kaizekblue)] w-8/12'>
                                Environmental Monitoring</h2>
                            </div>
                            <div className='col-span-2 py-4 sm:py-8 lg:py-14 px-4 sm:px-8 bg-[var(--ultraviolet)] rounded-xl lg:rounded-3xl'>
                                <ul className="font-symbol leading-tight text-[var(--whitetext)] text-base sm:text-2xl ms-4 lg:ms-8 xl:ms-12 px-2 list-outside space-y-2 text-left list-disc">
                                    <li>Air quality monitoring</li>
                                    <li>Weather monitoring</li>
                                    <li>Noise level monitoring</li>
                                    <li>Data analytics</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default SmartCity